/**
 * 스키마 비교 API (docs/features/28-schema-compare.md) — 비교 대상 → 오브젝트 → 결과 → 동기화 스크립트, 그리고 비교 기준.
 * LLM 을 부르지 않고 DB 를 바꾸지 않는다(스크립트는 글이다 — 실행은 사람이 편집기에서).
 */
import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_BASE_URL || '/sql-developer';
const ROOT = `${BASE_URL}/schema-compare`;
const enc = encodeURIComponent;
const LONG = { timeout: 10 * 60 * 1000 };

export async function listSchemas(connectionId) { return (await axios.get(`${ROOT}/schemas`, { params: { connectionId } })).data; }

export async function listCriteria() { return (await axios.get(`${ROOT}/criteria`)).data; }
export async function saveCriteria({ id, name, spec }) {
  return (id ? await axios.put(`${ROOT}/criteria/${enc(id)}`, { name, spec }) : await axios.post(`${ROOT}/criteria`, { name, spec })).data;
}
export async function deleteCriteria(id) { return (await axios.delete(`${ROOT}/criteria/${enc(id)}`)).data; }

export async function listJobs() { return (await axios.get(`${ROOT}/jobs`)).data; }
/** 비교 실행 — jobId 가 있으면 그 비교를 다시 */
export async function runCompare({ spec, title, criteriaId, jobId }) { return (await axios.post(`${ROOT}/jobs`, { spec, title, criteriaId, jobId }, LONG)).data; }
export async function cancelCompare() { return (await axios.post(`${ROOT}/cancel`, {})).data; }
export async function getJob(id) { return (await axios.get(`${ROOT}/jobs/${enc(id)}`)).data; }
export async function renameJob(id, title) { return (await axios.put(`${ROOT}/jobs/${enc(id)}`, { title })).data; }
export async function deleteJob(id) { return (await axios.delete(`${ROOT}/jobs/${enc(id)}`)).data; }
/** 동기화 스크립트 글 — drop: 지우는 문장을 살린다 · physical: 물리 속성 문장을 넣는다 */
export async function getScript(id, { drop = false, physical = true } = {}) {
  return (await axios.get(`${ROOT}/jobs/${enc(id)}/script`, { params: { drop: drop ? '1' : '0', physical: physical ? '1' : '0' } })).data;
}
